<template>
  <svg class="icon" viewBox="0 0 1024 1024" :width="size" :height="size">
    <path d="M768 768V608a32 32 0 1 1 64 0V768h160a32 32 0 1 1 0 64H832v160a32 32 0 1 1-64 0V832H608a32 32 0 1 1 0-64H768z m-128 256h96H64a64 64 0 0 1-64-64V320l256-320h512a64 64 0 0 1 64 64v384a32 32 0 1 1-64 0V64H320v320H64v576h576a32 32 0 1 1 0 64zM96 320H256V96L96 320z" fill="#879CB8" p-id="58272"></path></svg>
</template>

<script>
  export default {
    props: {
      size: {
        default: '24'
      }
    }
  }
</script>

